import React from "react";
import SectionTitle from './section-title'
import "./book-page.m.css";

export default function AuthorEventBlocks() {
  return (
    <section styleName="author-events">
      {/* Author Spotlight */}
      <div styleName="author-card">
        <SectionTitle
          title="Author Spotlight"
          width="30%"
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-08-07/c5ietqkn/author.png"
          alt="Author Spotlight"
          styleName="author-events-image"
        />
      </div>

      {/* Events */}
      <div styleName="events-card">
        <SectionTitle
          title="Events"
          width="14%"
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-08-07/za5p7cb4/events.png"
          alt="Events"
          styleName="author-events-image"
        />
      </div>
    </section>
  );
}